import { Plan, ProjectType, usePlansAdminService } from 'nekst-api';
import { AfterSubmitFunc, FormTemplate } from 'ui-builder';
import { FormText } from 'features/nekst-widgets';
import React from 'react';
import { ProjectTypeDropdown } from 'features/tasks-forms';

export function ChangeGlobalPlanTypeForm(
  props: {
    plan: Plan,
    title?: string,
    message?: string,
    afterSubmitFunc?: AfterSubmitFunc,
  },
) {
  const planService = usePlansAdminService();

  return (
    <FormTemplate<{ projectType: ProjectType }, Plan>
      submitFormFunc={async (data) => {
        return planService.changeProjectType(props.plan.id, data.projectType);
      }}
      afterSubmitFunc={props.afterSubmitFunc}
      title={props.title || 'Change Workflow Type'}
      initialData={{
        projectType: props.plan.projectType,
      }}
      validationSchema={{
        projectType: {
          type: 'string',
          constraints: {
            required: true,
          },
        },
      }}
    >
      <FormText>
        {props.message || (
          <>
            Changing the &quot;Type&quot; will remove all links between tasks and
            the Detail Boxes.
          </>
        )}
      </FormText>
      <ProjectTypeDropdown source="projectType" label="Transaction Type" />
    </FormTemplate>
  );
}
